export const TASK_PATH = "/tasks/:id";
